// Vue Router
import VueRouter from 'vue-router'
import AuthService from '@/services/auth.service'

import Cookies from 'js-cookie'

// Layout
const DefaultLayout = () => import('@/layouts/Default')

// Pages
const Index = () => import('@/pages/Index')
const Login = () => import('@/pages/login/Index')
const ValidateToken = () => import('@/pages/validate-token/Index')
const ChangePassword = () => import('@/pages/change-password/Index')
const About = () => import('@/pages/about/Index')
const Styleguide = () => import('@/pages/styleguide/Index')

// Error Pages
const Page404 = () => import('@/pages/404')
const Page500 = () => import('@/pages/500')

// Banner Pages
const Banners = () => import('@/pages/banners/Datatable')
const Banner = () => import('@/pages/banners/View')
const Order = () => import('@/pages/banners/Order')

// Popup Pages
const Popups = () => import('@/pages/popups/Datatable')
const Popup = () => import('@/pages/popups/View')

// Institutional pages
const Institutionals = () => import('@/pages/institutional/Datatable')
const Institutional = () => import('@/pages/institutional/View')

// Timeline pages
const Timelines = () => import('@/pages/institutional/timeline/Datatable')
const Timeline = () => import('@/pages/institutional/timeline/View')

// Direction pages
const Directions = () => import('@/pages/institutional/direction/Datatable')
const Direction = () => import('@/pages/institutional/direction/View')

// Certificates pages
const Certificates = () => import('@/pages/institutional/certificates/Datatable')
const Certificate = () => import('@/pages/institutional/certificates/View')
const CertificatesOrder = () => import('@/pages/institutional/certificates/Order')

// Products
const Products = () => import('@/pages/products/Datatable')
const Product = () => import('@/pages/products/View')

// Subproducts
const Subproducts = () => import('@/pages/products/subproducts/Datatable')
const Subproduct = () => import('@/pages/products/subproducts/View')

// Products Categories
const ProductsCategories = () => import('@/pages/products/products-category/Datatable')
const ProductCategory = () => import('@/pages/products/products-category/View')
const ProductsCategoryOrder = () => import('@/pages/products/products-category/Order')

// Products Subcategories
const ProductsSubcategories = () => import('@/pages/products/products-subcategory/Datatable')
const ProductSubcategory = () => import('@/pages/products/products-subcategory/View')

// Solutions
const Solutions = () => import('@/pages/solutions/Datatable')
const Solution = () => import('@/pages/solutions/View')
const SolutionsOrder = () => import('@/pages/solutions/Order')

// Aplications
const Aplications = () => import('@/pages/aplications/Datatable')
const Aplication = () => import('@/pages/aplications/View')

// Publications
const Publications = () => import('@/pages/publications/Datatable')
const Publication = () => import('@/pages/publications/View')

// Chapters
const Chapters = () => import('@/pages/chapters/Datatable')
const Chapter = () => import('@/pages/chapters/View')

// Work With Us
const WorkUsDatatable = () => import('@/pages/work-with-us/Datatable')
const WorkUsView = () => import('@/pages/work-with-us/View')

// Contact
const Contacts = () => import('@/pages/contact/Datatable')
const Contact = () => import('@/pages/contact/View')

// Department
const Departments = () => import('@/pages/contact/department/Datatable')
const Department = () => import('@/pages/contact/department/View')

// Newsletter
const Newsletters = () => import('@/pages/contact/newsletter/Datatable')
const Newsletter = () => import('@/pages/contact/newsletter/View')

// Sections
const Sections = () => import('@/pages/sections/Datatable')
const Section = () => import('@/pages/sections/View')

// Restricts Users
const UsersRestrict = () => import('@/pages/users-restrict/Datatable')
const UserRestrict = () => import('@/pages/users-restrict/View')

// News Pages
const NewsDatatable = () => import('@/pages/news/Datatable')
const NewsView = () => import('@/pages/news/View')

// News Category Pages
const NewsCategoryDatatable = () => import('@/pages/news-category/Datatable')
const NewsCategoryView = () => import('@/pages/news-category/View')

// Newsletters Pages
const NewslettersDatatable = () => import('@/pages/newsletters/Datatable')
const NewslettersView = () => import('@/pages/newsletters/View')

// Parameters Education Pages
const ParametersEducationDatatable = () => import('@/pages/parameters/education/Datatable')
const ParametersEducationView = () => import('@/pages/parameters/education/View')

// Parameters Interest Pages
const ParametersInterestDatatable = () => import('@/pages/parameters/interest/Datatable')
const ParametersInterestView = () => import('@/pages/parameters/interest/View')

// Parameters Training Pages
const ParametersTrainingDatatable = () => import('@/pages/parameters/training/Datatable')
const ParametersTrainingView = () => import('@/pages/parameters/training/View')

// Users Pages
const Users = () => import('@/pages/users/Datatable')
const User = () => import('@/pages/users/View')

// Permissions Pages
const Permissions = () => import('@/pages/permissions/Datatable')
const Permission = () => import('@/pages/permissions/View')

// Distributors Pages
const Distributors = () => import('@/pages/distributors/Datatable')

// SEO
const SEO = () => import('@/pages/seo/Index')

// Cookies
const CookiesPage = () => import('@/pages/cookies/Index')

// Mailbox
const Mailbox = () => import('@/pages/mailbox/Index')

// Settings
const Settings = () => import('@/pages/settings/Index')

// Router
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/change-password/:token',
      name: 'Alterar senha',
      component: ChangePassword
    },
    {
      path: '/change-password/expired/:token',
      name: 'Alterar senha expirada',
      component: ChangePassword
    },
    {
      path: '/validate-token',
      name: 'Validar o token de acesso',
      component: ValidateToken
    },
    {
      path: '/',
      name: 'Home',
      redirect: '/dashboard',
      component: DefaultLayout,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Index
        },
        {
          path: 'seo',
          name: 'SEO',
          component: SEO
        },
        {
          path: 'cookies',
          name: 'Cookies',
          component: CookiesPage
        },
        {
          path: 'settings',
          name: 'Configurações',
          component: Settings
        },
        {
          path: 'banners',
          name: 'Banners',
          redirect: 'banners/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Banners
            },
            {
              path: 'create',
              name: 'Cadastrar Banner',
              component: Banner
            },
            {
              path: 'edit/:id',
              name: 'Editar Banner',
              component: Banner
            },
            {
              path: 'order',
              name: 'Ordenar Banner',
              component: Order
            }
          ]
        },
        {
          path: 'popups',
          name: 'Popups',
          redirect: 'popups/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Popups
            },
            {
              path: 'edit/:id',
              name: 'Editar Popups',
              component: Popup
            }
          ]
        },
        {
          path: 'institutional',
          name: 'Institucional',
          redirect: 'institutional/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Institutionals
            },
            {
              path: 'edit/:id',
              name: 'Editar Institucional',
              component: Institutional
            }
          ]
        },
        {
          path: 'timeline',
          name: 'Timeline',
          redirect: 'timeline/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Timelines
            },
            {
              path: '/timeline/create',
              name: 'Cadastrar Linha do Tempo',
              component: Timeline
            },
            {
              path: '/timeline/edit/:id',
              name: 'Editar Linha do Tempo',
              component: Timeline
            }
          ]
        },
        {
          path: 'direction',
          name: 'Direção',
          redirect: 'direction/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Directions
            },
            {
              path: '/direction/create',
              name: 'Cadastrar Direção',
              component: Direction
            },
            {
              path: '/direction/edit/:id',
              name: 'Editar Direção',
              component: Direction
            }
          ]
        },
        {
          path: 'certificates',
          name: 'Certificados',
          redirect: 'certificates/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Certificates
            },
            {
              path: '/certificates/create',
              name: 'Cadastrar Certificação',
              component: Certificate
            },
            {
              path: '/certificates/edit/:id',
              name: 'Editar Certificação',
              component: Certificate
            },
            {
              path: '/certificates/order',
              nama: 'Ordernar Certificações',
              component: CertificatesOrder
            }
          ]
        },
        {
          path: 'products',
          name: 'Produtos',
          redirect: 'products/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Products
            },
            {
              path: '/products/create',
              name: 'Cadastrar Produto',
              component: Product
            },
            {
              path: '/products/edit/:id',
              name: 'Editar Produto',
              component: Product
            }
          ]
        },
        {
          path: 'subproducts',
          name: 'Subprodutos',
          redirect: 'subproducts/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Subproducts
            },
            {
              path: '/subproducts/edit/:id',
              name: 'Editar Subproduto',
              component: Subproduct
            }
          ]
        },
        {
          path: 'products-category',
          name: 'Categorias',
          redirect: 'products-category/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: ProductsCategories
            },
            {
              path: '/products-category/order',
              name: 'Ordernar Categoria',
              component: ProductsCategoryOrder
            },
            {
              path: '/products-category/create',
              name: 'Cadastrar Categoria',
              component: ProductCategory
            },
            {
              path: '/products-category/edit/:id',
              name: 'Editar Categoria',
              component: ProductCategory
            }
          ]
        },
        {
          path: 'products-subcategory',
          name: 'Subcategorias',
          redirect: 'products-subcategory/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: ProductsSubcategories
            },
            {
              path: '/products-subcategory/create',
              name: 'Cadastrar Subcategoria',
              component: ProductSubcategory
            },
            {
              path: '/products-subcategory/edit/:id',
              name: 'Editar Subcategoria',
              component: ProductSubcategory
            }
          ]
        },
        {
          path: 'solutions',
          name: 'Soluções',
          redirect: 'solutions/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Solutions
            },
            {
              path: '/solutions/create',
              name: 'Cadastrar Solução',
              component: Solution
            },
            {
              path: '/solutions/edit/:id',
              name: 'Editar Solução',
              component: Solution
            },
            {
              path: '/solutions/order',
              name: 'Ordernar Soluções',
              component: SolutionsOrder
            }
          ]
        },
        {
          path: 'aplications',
          name: 'Aplicações',
          redirect: 'aplications/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Aplications
            },
            {
              path: '/aplications/create',
              name: 'Cadastrar Aplicação',
              component: Aplication
            },
            {
              path: '/aplications/edit/:id',
              name: 'Editar Aplicação',
              component: Aplication
            }
          ]
        },
        {
          path: 'publications',
          name: 'Publicações',
          redirect: 'publications/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Publications
            },
            {
              path: '/publications/create',
              name: 'Cadastrar Publicação',
              component: Publication
            },
            {
              path: '/publications/edit/:id',
              name: 'Editar Publicação',
              component: Publication
            }
          ]
        },
        {
          path: 'chapters',
          name: 'Seções',
          redirect: 'chapters/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Chapters
            },
            {
              path: '/chapters/create',
              name: 'Cadastrar Seção',
              component: Chapter
            },
            {
              path: '/chapters/edit/:id',
              name: 'Editar Seção',
              component: Chapter
            }
          ]
        },
        {
          path: 'work-with-us',
          name: 'Trabalhe Conosco',
          redirect: 'work-with-us/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: WorkUsDatatable
            },
            {
              path: '/work-with-us/edit/:id',
              name: 'Visualizar',
              component: WorkUsView
            }
          ]
        },
        {
          path: 'parameters/education',
          name: 'Parâmetros - Educação',
          redirect: 'parameters/education',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: 'Nível de escolaridade',
              component: ParametersEducationDatatable
            },
            {
              path: 'create',
              name: 'Nova escolaridade',
              component: ParametersEducationView
            },
            {
              path: 'edit/:id',
              name: 'Editar escolaridade',
              component: ParametersEducationView
            }
          ]
        },
        {
          path: 'parameters/interest',
          name: 'Parâmetros - Interesses',
          redirect: 'parameters/interest',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: 'Áreas de Interesse',
              component: ParametersInterestDatatable
            },
            {
              path: 'create',
              name: 'Novo Interesse',
              component: ParametersInterestView
            },
            {
              path: 'edit/:id',
              name: 'Editar Interesse',
              component: ParametersInterestView
            }
          ]
        },
        {
          path: 'parameters/training',
          name: 'Parâmetros - Área de formação',
          redirect: 'parameters/training',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: 'Áreas de formação',
              component: ParametersTrainingDatatable
            },
            {
              path: 'create',
              name: 'Nova Área de formação',
              component: ParametersTrainingView
            },
            {
              path: 'edit/:id',
              name: 'Editar Área de formação',
              component: ParametersTrainingView
            }
          ]
        },
        {
          path: 'contact',
          name: 'Contato',
          redirect: 'contact/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Contacts
            },
            {
              path: '/contact/edit/:id',
              name: 'Visualizar',
              component: Contact
            }
          ]
        },
        {
          path: 'departament',
          name: 'Departamento',
          redirect: 'departament/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Departments
            },
            {
              path: '/departament/create',
              name: 'Cadastrar Departamento',
              component: Department
            },
            {
              path: '/departament/edit/:id',
              name: 'Editar Departamento',
              component: Department
            }
          ]
        },
        {
          path: 'newsletter',
          name: 'Newsletter',
          redirect: 'newsletter/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Newsletters
            },
            {
              path: '/newsletter/edit/:id',
              name: 'Newsletter',
              component: Newsletter
            }
          ]
        },
        {
          path: 'sections',
          name: 'Seção',
          redirect: 'sections/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Sections
            },
            {
              path: '/sections/create',
              component: Section
            },
            {
              path: '/sections/edit/:id',
              name: 'Editar Seção',
              component: Section
            }
          ]
        },
        {
          path: 'users-restrict',
          name: 'Usuários Restritos',
          redirect: 'users-restrict/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: UsersRestrict
            },
            {
              path: '/users-restrict/create',
              component: UserRestrict
            },
            {
              path: '/users-restrict/edit/:id',
              name: 'Editar Usuário',
              component: UserRestrict
            }
          ]
        },
        {
          path: 'styleguide',
          name: 'Styleguide',
          component: Styleguide
        },
        {
          path: 'seo',
          name: 'SEO',
          component: SEO
        },
        {
          path: 'settings',
          name: 'Configurações',
          component: Settings
        },
        {
          path: 'news',
          name: 'Notícias',
          redirect: 'news/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: NewsDatatable
            },
            {
              path: 'create',
              name: 'Cadastrar Notícia',
              component: NewsView
            },
            {
              path: 'edit/:id',
              name: 'Editar Notícia',
              component: NewsView
            }
          ]
        },
        {
          path: 'newsletters',
          name: 'Newsletters',
          redirect: 'newsletters/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: NewslettersDatatable
            },
            {
              path: 'edit/:id',
              name: 'Editar Newsletter',
              component: NewslettersView
            }
          ]
        },
        {
          path: 'news-category',
          name: 'Categoria de Notícias',
          redirect: 'news-category/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: NewsCategoryDatatable
            },
            {
              path: 'create',
              name: 'Cadastrar Categoria',
              component: NewsCategoryView
            },
            {
              path: 'edit/:id',
              name: 'Editar Categoria',
              component: NewsCategoryView
            }
          ]
        },
        {
          path: 'distributors',
          name: 'Distribuidores',
          redirect: 'distributors/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              component: Distributors
            }
          ]
        },
        {
          path: 'mailbox',
          name: 'Mailbox',
          redirect: 'mailbox/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Mailbox
            },
            {
              path: ':id',
              name: 'Detalhes da mensagem',
              component: Mailbox
            }
          ]
        },
        {
          path: 'users',
          name: 'Usuários',
          redirect: 'users/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Users
            },
            {
              path: 'create',
              name: 'Novo Usuário',
              component: User
            },
            {
              path: 'edit/:id',
              name: 'Editar Usuario',
              component: User
            }
          ]
        },
        {
          path: 'permissions',
          name: 'Permissões',
          redirect: 'permissions/',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '/',
              name: '',
              component: Permissions
            },
            {
              path: 'create',
              name: 'Novo Papel',
              component: Permission
            },
            {
              path: 'edit/:id',
              name: 'Editar Papeis',
              component: Permission
            }
          ]
        },
        {
          path: 'about',
          name: 'Sobre',
          component: About
        }
      ]
    },
    {
      path: '/500',
      name: '500',
      component: Page500
    },
    {
      path: '*',
      name: '404',
      component: Page404
    }
  ]
})

/**
 // Authentication Logic //
 // Uncomment when API is ready to use //
*/
router.beforeEach(async(to, from, next) => {
  const publicPages = ['/login']

  if (to.path.includes('/change-password')) {
    publicPages.push(to.path)
  }

  const authRequired = !publicPages.includes(to.path)

  const loggedIn = Cookies.getJSON('intelli:user')
  const userId = Cookies.get('intelli:userId')
  const token = Cookies.get('intelli:token')
  const userHaveTwoFactorAuth = Cookies.get('intelli:userHaveTwoFactorAuth')

  if (userHaveTwoFactorAuth && to.path !== '/validate-token') {
    // Cookies.remove('intelli:user')
    // Cookies.remove('intelli:userId')
    // Cookies.remove('intelli:link')
    // next('/validate-token')
  }

  if (loggedIn) {
    await router.app.$store.dispatch('auth/login', token)
    // ************* REGRA QUE LIMITA O ACESSO AO MANAGER **************
    // if (loggedIn.data.user.roles[0].id !== 1) {
    //   Cookies.remove('intelli:user')
    //   Cookies.remove('intelli:token')
    //   Cookies.remove('intelli:userId')
    //   Cookies.remove('intelli:link')
    //   next('/login')
    // }
    if (loggedIn.pass_expired === 1) {
      Cookies.remove('intelli:user')
      Cookies.remove('intelli:userId')
      Cookies.remove('intelli:link')
      Cookies.set('intelli:userId', loggedIn.data.user.id)
      const token = await AuthService.passExpired(loggedIn.data.user.id)
      next(`/change-password/expired/${token}`)
    }
  }

  if (authRequired && !loggedIn) {
    Cookies.set('intelli:link', to.path)
    next('/login')
  } else if (from.path === '/login' && !userId && loggedIn) {
    const link = Cookies.get('intelli:link')

    Cookies.remove('intelli:link')

    if (link) {
      next(`${link}`)
    }

    next()
  }

  router.app.$root.$emit('update:routes')

  next()
})

export default router
